import React, {
	createContext,
	useContext,
	useEffect,
	useState,
	useRef,
} from "react";
import { io, Socket } from "socket.io-client";
import { useAuth } from "./auth";

interface SocketContextType {
	socket: Socket | null;
}

const SocketContext = createContext<SocketContextType>({ socket: null });

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const [socket, setSocket] = useState<Socket | null>(null);
	const { user } = useAuth();
	const socketRef = useRef<Socket | null>(null);

	useEffect(() => {
		if (!user?.id) return;

		const url = process.env.REACT_APP_HOSTNAME || "http://localhost:8585";

		socketRef.current = io(url, {
			withCredentials: true,
			transports: ["websocket"],
		});

		socketRef.current.on("connect", () => {
			console.log("Main App Socket connected");
		});

		setSocket(socketRef.current);

		return () => {
			if (socketRef.current) {
				socketRef.current.disconnect();
				socketRef.current = null;
				setSocket(null);
			}
		};
	}, [user?.id]);

	return (
		<SocketContext.Provider value={{ socket }}>
			{children}
		</SocketContext.Provider>
	);
};

export const useSocket = () => useContext(SocketContext);
